module.exports = __webpack_public_path__ + "img/pic-1-3.8e26f64e.jpg";